// extracted by mini-css-extract-plugin
export var arrowBtn = "relatedPost-module--arrowBtn--651bd";
export var arrowContainer = "relatedPost-module--arrowContainer--3c0bc";
export var arrowIcon = "relatedPost-module--arrowIcon--62ab5";
export var flexContainer = "relatedPost-module--flexContainer--0e6cb";
export var headerContainer = "relatedPost-module--headerContainer--775d1";
export var relatedPostsContainer = "relatedPost-module--relatedPostsContainer--98e63";
export var titleContainer = "relatedPost-module--titleContainer--826a3";